import React from "react";

// Contre-épreuve emblem: two identical offset frames (orange behind, ink front)
// whose confrontation leaves a white centre. Geometric, legible at small sizes.
export const CEmblem = ({ className = "", primary = "#111111", secondary = "#FF4D1C" }) => (
  <svg viewBox="0 0 100 100" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect x="10" y="14" width="56" height="56" rx="6" stroke={secondary} strokeWidth="11" />
    <rect x="34" y="30" width="56" height="56" rx="6" stroke={primary} strokeWidth="11" />
  </svg>
);
